import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleAnalyticsConnectorWrapper = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  '> div': {
    width: 'calc(100% - 40px)',
  },
  '> :not(:last-child)': {
    marginBottom: '$10',
  },
})
